export const heroStyles = {
  wrapper: {
    position: "relative",
    overflow: "hidden",
    bgcolor: "peach.main",
    zIndex: 5,
    borderRadius: {
      tablet: "0.938rem",
    },
    justifyContent: {
      laptop: "space-between",
    },
    px: {
      mobile: "1.5rem",
      laptop: "4rem",
    },
    mx: {
      tablet: "2.5rem",
    },
    maxHeight: {
      mobile: "52.688rem",
      laptop: "40rem",
    },
    maxWidth: {
      laptop: "69.4375rem",
    },
    textAlign: {
      mobile: "center",
      laptop: "left",
    },
  },
  container: {
    margin: {
      mobile: "5rem 1.5rem 3rem",
      tablet: "3.75rem 3.62rem 1rem",
      laptop: "9.5rem 3.62rem 1rem",
    },
    maxWidth: {
      laptop: "33.75rem",
    },
  },
  box: {
    margin: {
      mobile: "0.875rem 0 1.5rem 0",
      tablet: "2rem auto 1.2rem",
      laptop: "2rem 6rem 2.5rem 0",
    },
    maxWidth: {
      tablet: "27.8125rem",
      laptop: "unset",
    },
  },
  text: {
    color: "white.main",
  },
  bgImage: {
    position: "absolute",
    zIndex: "-1",
    top: {
      mobile: "6.625rem",
      laptop: "unset",
    },
    left: {
      laptop: "30rem",
    },
  },
  image: {
    margin: {
      mobile: "-7.5rem -10rem 0",
      tablet: "-7.5rem auto 0",
      laptop: "-0.5rem -10rem 0",
    },
  },
};
